<template>
    <div id="addcart-div">
        <!-- 首页&搜索页 Start -->
        <template v-if="product.Id && !product.IsSoldOut && !product.IsOutBusinessScope && fromPage != 'isArriving' && fromPage != 'newProduct' && fromPage != 'ActivityArea'">
            <template v-if="fromPage == 'HomeNewGoods'">
                <div v-if="product.Stock > 0"
                     class="cartNum">
                    <van-stepper input-width="50px"
                                 button-size="28px"
                                 v-model="cartNum"
                                 :min="product.OutPurchaseAgreementDto.PurchaseNumber"
                                 :step="product.OutPurchaseAgreementDto.StepLengthNumber"
                                 :disable-plus="cartNum >= product.Stock"
                                 integer />
                </div>
                <div :style="{ marginLeft: product.Stock <= 0 ? '0' : '11px' }"
                     :class="`${product.Stock <= 0 ? (product.ArrivalNotices ? 'gray-button' : 'red-button') : 'addcart-button'}`">
                    <div v-if="product.Stock <= 0"
                         @click.stop="getCollect(Enum_CollectType.Subscribe)">{{ product.ArrivalNotices ? '已订阅' : '到货通知' }}</div>
                    <div v-else
                         @click.stop="confirmCart">加入购物车</div>
                </div>
            </template>
            <template v-if="fromPage == 'VGoods'">
                <div class="vGoods flex-row">
                    <div class="v-cartNum"
                         v-if="product.Stock > 0">
                        <van-stepper v-model="cartNum"
                                     :min="product.OutPurchaseAgreementDto.PurchaseNumber"
                                     :step="product.OutPurchaseAgreementDto.StepLengthNumber"
                                     integer />
                    </div>
                    <div :class="`${product.Stock <= 0 ? (product.ArrivalNotices ? 'v-gray-button' : 'v-red-button') : 'v-button'}`">
                        <div v-if="product.Stock <= 0"
                             @click.stop="getCollect(Enum_CollectType.Subscribe)">{{ product.ArrivalNotices ? '已订阅' : '到货通知' }}</div>
                        <div v-else
                             @click.stop="confirmCart">加入购物车</div>
                    </div>
                </div>
            </template>
        </template>
        <!-- 首页&搜索页 End -->
        <!-- 列表用 Start -->
        <template v-if="product.Id && !product.IsSoldOut && !product.IsOutBusinessScope && fromPage == 'newProduct'">
            <div v-if="product.Stock > 0"
                 class="notice-cartNum">
                <van-stepper input-width="50px"
                             button-size="34px"
                             style="padding-top:20px; padding-right:28px;"
                             v-model="cartNum"
                             :min="product.OutPurchaseAgreementDto.PurchaseNumber"
                             :step="product.OutPurchaseAgreementDto.StepLengthNumber"
                             integer />
            </div>
            <div :class="`${parseInt(product.Stock) <= 0 ? (product.ArrivalNotices ? 'notice-gray-button' : 'notice-button') : 'notice-button'}`">
                <div v-if="parseInt(product.Stock) <= 0"
                     @click.stop="getCollect(Enum_CollectType.Subscribe)">{{ product.ArrivalNotices ? '已订阅' : '到货通知' }}</div>
                <div v-else
                     @click.stop="confirmCart">加入购物车</div>
            </div>
        </template>
        <template v-if="product.Id && !product.IsSoldOut && !product.IsOutBusinessScope && fromPage == 'ActivityArea'">
            <div v-if="parseInt(product.Stock) > 0"
                 class="ActivityArea"
                 style="width:142px; height:100%;">
                <van-stepper input-width="55px"
                             button-size="40px"
                             v-model="cartNum"
                             :min="product.OutPurchaseAgreementDto.PurchaseNumber"
                             :step="product.OutPurchaseAgreementDto.StepLengthNumber"
                             :disable-plus="cartNum >= product.Stock"
                             integer />
            </div>
            <div :class="`${parseInt(product.Stock) <= 0 ? (product.ArrivalNotices ? 'notice-gray-full-button' : 'notice-full-button') : 'notice-full-button'}`">
                <div v-if="parseInt(product.Stock) <= 0"
                     @click.stop="getCollect(Enum_CollectType.Subscribe)">{{ product.ArrivalNotices ? '已订阅' : '到货通知' }}</div>
                <div v-else
                     @click.stop="confirmCart">加入购物车</div>
            </div>
        </template>
        <template v-else-if="fromPage == 'isArriving'">
            <div :class="`${product.ArrivalNotices ? 'notice-gray-button' : 'notice-button'}`">
                <div @click.stop="getCollect(Enum_CollectType.Subscribe)">{{ product.ArrivalNotices ? '已订阅' : '到货通知' }}</div>
            </div>
        </template>
        <!-- 列表用 End -->
    </div>
</template>

<script>
import moment from 'moment';
import { BaseMixin } from '@/mixins/BaseMixin';
import { CollectType } from '@/dictionary/goods.js';

export default {
    name: 'AddCartButton',
    mixins: [BaseMixin],
    props: {
        product: {
            type: Object,
            default () {
                return {};
            }
        },
        fromPage: {
            type: String,
            default () {
                return '';
            }
        }
    },
    components: {},
    data () {
        return {
            Enum_CollectType: CollectType,
            collects: {
                Goods: { Id: '', IsCollect: false },
                Subscribe: { Id: '', IsCollect: false }
            },
            cartNum: 0,
            url: {
                addOrUpdateCart: '/api_order/ShoppingCarts/AddOrUpdateCart',
                createLike: '/api_customer/CustomerCollect/Create', //客户收藏&订阅到货通知
                deleteLike: '/api_customer/CustomerCollect/PhysicalDeleteBatch', //客户取消收藏&到货通知
                getCollect: '/api_customer/CustomerCollect/IsCollect' //是否收藏&订阅
            }
        };
    },
    methods: {
        moment,
        //确认购物车
        async confirmCart () {
            if (this.cartNum > this.product.Stock) {
                this.$toast({
                    position: 'bottom',
                    message: '购买商品数量超过了该商品库存，库存余（' + this.product.Stock + '）'
                });
                this.cartNum=this.product.Stock;
                return;
            }
            if (!!this.product.LimitPerOrder && this.cartNum > this.product.LimitPerOrder) {
                this.$toast({
                    position: 'bottom',
                    message:
                        '单笔订单限购（' +
                        this.product.LimitPerOrder +
                        '）' + this.product.Unit,
                })
                this.cartNum = this.$hys.checkLimitPerOrder(this.product.OutPurchaseAgreementDto.PurchaseNumber, this.product.OutPurchaseAgreementDto.StepLengthNumber, this.product.LimitPerOrder)
                return
            }
            this.product.cartNum = this.cartNum;
            let res = await this.postAction(this.url.addOrUpdateCart, {
                ProductSKUId: this.product.Id,
                Count: this.product.cartNum                
            });
            if (res.IsSuccess) {
                this.$nextTick(() => {
                    if (res.Data.CountData) {
                        // 判断是否可以加购
                        if (res.Data.IsLimitPerOrder) {
                            this.$toast({
                                position: 'bottom',
                                message: '单笔订单限购（' +
                                    this.product.LimitPerOrder +
                                    '）' + this.product.Unit,
                            })
                            return false;
                        }
                        this.$bus.$emit('buycarChanged', res.Data.CountData.ProductCount, true);
                        this.$bus.$emit('rightBuycarChanged', res.Data.CountData.ProductCount, true);
                    }
                    this.$toast({ position: 'center', message: '添加购物车成功' });
                });
            } else {
                this.$toast({ position: 'bottom', message: res.Msg });
            }
        },

        //订阅收藏 -------------------------------------------------------------------
        //操作订阅收藏
        async operateCollect (collectType) {
            let key = collectType == this.Enum_CollectType.Goods ? 'Goods' : 'Subscribe';
            let isCollect = this.collects[key].IsCollect;
            let collectId = this.collects[key].Id;
            if (isCollect) {
                this.cancelCollect(collectType, key, collectId);
            } else {
                this.setCollect(collectType, key);
            }
        },

        //订阅&收藏
        async setCollect (collectType, key) {
            let title = collectType == this.Enum_CollectType.Goods ? '收藏成功' : '订阅成功';
            const data = {
                CollectType: collectType,
                CollectingBusinessId: this.product.Id,
                CollectionPrice: this._getProductPrice(this.product.PriceActivity, this.product.PriceLimit)
            };
            const res = await this.postAction(`${this.url.createLike}`, data);
            // console.log('收藏订阅', res)
            if (res.IsSuccess) {
                this.collects[key].Id = res.Data;
                this.collects[key].IsCollect = true;
                this.product.ArrivalNotices = true;
                this.$toast(title);
            } else {
                this.$toast({ position: 'bottom', message: res.Msg });
            }
        },
        //取消订阅&收藏
        async cancelCollect (collectType, key, collectId) {
            let title = collectType == this.Enum_CollectType.Goods ? '取消收藏成功' : '取消订阅成功';
            this.$hys.openLoading();
            const res = await this.deleteAction(`${this.url.deleteLike}?ids=${collectId}`);
            this.$hys.clearLoading();
            // console.log('取消收藏订阅', res)
            if (res.IsSuccess) {
                this.collects[key].Id = '';
                this.collects[key].IsCollect = false;
                this.product.ArrivalNotices = false;
                this.$toast(title);
            } else {
                this.$toast({ position: 'bottom', message: res.Msg });
            }
        },
        //获取收藏订阅
        async getCollect (collectType) {
            const res = await this.getAction(`${this.url.getCollect}?collectingBusinessId=${this.product.Id}`);
            // console.log('获取收藏订阅详情', res)
            if (res.IsSuccess) {
                const data = res.Data;
                let goodsCollects = data.filter(item => item.CollectType == this.Enum_CollectType.Goods);
                let subscribeCollects = data.filter(item => item.CollectType == this.Enum_CollectType.Subscribe);
                if (goodsCollects.length > 0) {
                    this.collects['Goods'].Id = goodsCollects[0].Id;
                    this.collects['Goods'].IsCollect = true;
                }
                if (subscribeCollects.length > 0) {
                    this.collects['Subscribe'].Id = subscribeCollects[0].Id;
                    this.collects['Subscribe'].IsCollect = true;
                    this.product.ArrivalNotices = true;
                }
                this.operateCollect(collectType);
            } else {
                //   this.$toast(res.Msg)
            }
        }
        //------------------------------------------------------------------- 订阅收藏/
    }
};
</script>

<style lang="less">
#addcart-div {
    display: flex;
    flex-direction: row;
    .red-button,
    .gray-button,
    .addcart-button {
        width: 96px;
        height: 28px;
        background: rgba(255, 57, 57, 1);
        border-radius: 2px;
        font-size: 14px;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        line-height: 28px;
        cursor: pointer;
    }

    .cartNum {
        /deep/ .van-stepper__input {
            width: 50px;
            height: 28px;
            border: 1px solid rgba(232, 232, 232, 1);
            background-color: transparent;
            margin: 0;
            font-size: 16px;
            color: rgba(34, 34, 34, 1);
        }

        /deep/ .van-stepper__minus {
            width: 30px;
            height: 28px;
            background: rgba(246, 246, 246, 1);
            border-radius: 2px 0px 0px 2px;
            border: 1px solid rgba(232, 232, 232, 1);
        }

        /deep/ .van-stepper__plus {
            width: 30px;
            height: 28px;
            background: rgba(246, 246, 246, 1);
            border-radius: 2px 0px 0px 2px;
            border: 1px solid rgba(232, 232, 232, 1);
        }

        /deep/ .van-stepper__minus::after,
        .van-stepper__plus::after {
            width: 2px;
            height: 10px;
        }

        /deep/ .van-stepper__minus::before,
        .van-stepper__plus::before {
            width: 30%;
            height: 2px;
        }
    }

    .red-button:hover,
    .addcart-button:hover {
        background: #ff0000;
    }

    .gray-button:hover {
        background: #c2c2c2;
    }

    .gray-button {
        background: rgba(209, 209, 209, 1);
    }

    .vGoods {
        box-shadow: 0px 1px 6px 0px #e5e5e5,
            0px -2px 5px 0px rgba(229, 229, 229, 0.5);
        flex: 1;
        .v-cartNum {
            background: #fff;
            display: flex;
            flex-direction: column;
            justify-content: center;
            /deep/ .van-stepper__input {
                width: 48px;
                height: 60px;
                margin: 0;
                font-size: 20px;
                background: rgba(255, 255, 255, 1);
                font-weight: 600;
                color: rgba(153, 153, 153, 1);
            }

            /deep/ .van-stepper__minus {
                width: 47px;
                height: 60px;
                background: rgba(255, 255, 255, 1);
            }

            /deep/ .van-stepper__plus {
                width: 47px;
                height: 60px;
                background: rgba(255, 255, 255, 1);
                border-radius: 0;
            }

            /deep/ .van-stepper__minus::after,
            .van-stepper__plus::after {
                width: 3px;
                height: 25%;
            }

            /deep/ .van-stepper__minus::before,
            .van-stepper__plus::before {
                width: 30%;
                height: 3px;
            }
        }
    }

    .v-button,
    .v-red-button,
    .v-gray-button {
        height: 60px;
        font-size: 18px;
        font-weight: 600;
        text-align: center;
        line-height: 60px;
    }

    .v-button {
        width: 143px;
        color: rgba(255, 255, 255, 1);
        background: rgba(255, 57, 57, 1);
        flex: 1;
    }

    .v-gray-button {
        width: 285px;
        background: rgba(209, 209, 209, 1);
        color: #ffffff;
    }

    .v-red-button {
        width: 285px;
        color: rgba(255, 255, 255, 1);
        background: rgba(255, 57, 57, 1);
    }

    .v-button,
    .v-red-button:hover {
        background: #ff0000;
    }

    .v-gray-button:hover {
        background: #c2c2c2;
    }

    .notice-cartNum {
        /deep/ .van-stepper__input {
            width: 64px;
            height: 36px;
            border: 1px solid rgba(232, 232, 232, 1);
            background-color: transparent;
            margin: 0;
            font-size: 20px;
            color: rgba(34, 34, 34, 1);
        }

        /deep/ .van-stepper__minus {
            width: 40px;
            height: 36px;
            background: rgba(246, 246, 246, 1);
            border-radius: 2px 0px 0px 2px;
            border: 1px solid rgba(232, 232, 232, 1);
        }

        /deep/ .van-stepper__plus {
            width: 40px;
            height: 36px;
            background: rgba(246, 246, 246, 1);
            border-radius: 2px 0px 0px 2px;
            border: 1px solid rgba(232, 232, 232, 1);
        }

        /deep/ .van-stepper__minus::after,
        .van-stepper__plus::after {
            width: 2px;
            height: 12px;
        }

        /deep/ .van-stepper__minus::before,
        .van-stepper__plus::before {
            width: 30%;
            height: 2px;
        }
    }

    .notice-gray-button,
    .notice-button {
        width: 124px;
        background: rgba(255, 57, 57, 1);
        font-size: 16px;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        line-height: 36px;
        margin-top: 18px;
        vertical-align: middle;
        cursor: pointer;
        border-radius: 2px;
    }

    .notice-button:hover {
        background: #ff0000;
    }

    .notice-gray-button:hover {
        background: #c2c2c2;
    }

    .notice-gray-button {
        background: rgba(209, 209, 209, 1);
        color: #ffffff;
    }

    .notice-gray-full-button,
    .notice-full-button {
        width: 142px;
        background: rgba(255, 57, 57, 1);
        font-size: 16px;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        line-height: 60px;
        vertical-align: middle;
        cursor: pointer;
    }

    .notice-gray-full-button {
        background: rgba(209, 209, 209, 1);
        color: #ffffff;
    }

    .ActivityArea {
        padding-left: 2px;
        padding-right: 2px;
        margin-top: 10px;

        > .van-stepper__input {
            height: 40px;
        }

        > .van-stepper__plus {
            width: 36px;
            height: 40px;
        }
    }
}
</style>
